var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_931_28171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.300049 22.05L12 0.849976L24.3 22.05H-0.300049ZM12.025 18.675C12.3916 18.675 12.7041 18.5458 12.9625 18.2875C13.2208 18.0291 13.35 17.7166 13.35 17.35C13.35 16.9833 13.2208 16.6708 12.9625 16.4125C12.7041 16.1541 12.3916 16.025 12.025 16.025C11.6583 16.025 11.3458 16.1541 11.0875 16.4125C10.8291 16.6708 10.7 16.9833 10.7 17.35C10.7 17.7166 10.8291 18.0291 11.0875 18.2875C11.3458 18.5458 11.6583 18.675 12.025 18.675ZM10.7 15.1H13.35V9.99998H10.7V15.1Z",
    fill: "#F26522"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_931_28171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.378a22cdf8db940d2c2d3b0490751565.svg";
export { ForwardRef as ReactComponent };